import Typography from '@classify/react-core-components/Typography';
import { makeStyles } from '@mui/styles';
import ROUTES from '@openclassrooms/routing/routes';
import { ImageCdn } from '@openclassrooms/images-cdn';
import type { CourseCreator } from '../../types';

interface CourseCreatorsProps {
  creators: Array<CourseCreator>;
}

const useStyles = makeStyles(({ spacing, breakpoints }) => ({
  creatorsContent: {
    display: 'flex',
    alignItems: 'center',

    '&:not(:first-of-type)': {
      marginTop: spacing(4),

      [breakpoints.up('sm')]: {
        marginTop: 0,
      },
    },

    [breakpoints.up('sm')]: {
      marginTop: 0,
      marginRight: spacing(4),
    },
  },
  textContent: {
    display: 'flex',
    marginLeft: spacing(2),
    alignItems: 'center',
  },
  logo: {
    height: 56,

    [breakpoints.up('sm')]: {
      height: 80,
    },
  },
}));

const CourseCreators = ({ creators }: CourseCreatorsProps) => {
  const classes = useStyles();
  return (
    <>
      {creators.map((creator) => (
        <div className={classes.creatorsContent} key={creator.id}>
          <ImageCdn className={classes.logo} src={creator.logo} />

          <Typography
            className={classes.textContent}
            variant="h6"
            component="a"
            href={`${ROUTES.PARTNERS.INDEX}/${creator.id}`}
          >
            {creator.name}
          </Typography>
        </div>
      ))}
    </>
  );
};

export default CourseCreators;
